import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarPinFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m20.04 9.253-5.3-5.3c-.756-.757-2.074-.757-2.83 0l-.591.592c-.57.57-.742 1.422-.423 2.207.154.374.069.8-.216 1.087L9.344 9.174a1 1 0 0 1-.41.248l-3.163.99a2.04 2.04 0 0 0-.814.494 2 2 0 0 0-.587 1.416c0 .536.209 1.037.587 1.414l2.119 2.118-3.48 3.48a.75.75 0 0 0 1.06 1.061l3.48-3.48 2.122 2.122c.389.389.9.582 1.413.582a2 2 0 0 0 1.909-1.398l.989-3.16a1 1 0 0 1 .248-.41l1.337-1.338c.285-.287.709-.372 1.12-.205a2 2 0 0 0 2.174-.434l.592-.592a2.003 2.003 0 0 0 0-2.829"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarPinFilled);
export default ForwardRef;
